import { useEffect, useState } from 'react';
import { getOperazioniReportPagamenti } from '../../../redux/report/api';

const useOperazioniDataPagamenti = () => {
  const [isLoadingOperazioniData, setIsLoadingOperazioniData] = useState(false);
  const [operazioniData, setOperazioniData] = useState(null);
  const [loadingErrorOperazioniData, setLoadingErrorOperazioniData] =
    useState(null);

  const dataLoad = async () => {
    setIsLoadingOperazioniData(true);
    try {
      const response = await getOperazioniReportPagamenti();
      setOperazioniData(response);
    } catch (error) {
      setLoadingErrorOperazioniData(error);
    } finally {
      setIsLoadingOperazioniData(false);
    }
  };

  useEffect(() => {
    dataLoad();
  }, []);

  return {
    isLoadingOperazioniData,
    operazioniData,
    loadingErrorOperazioniData,
  };
};

export default useOperazioniDataPagamenti;
